import { render, staticRenderFns } from "./home.vue?vue&type=template&id=675fc5dd&scoped=true&"
var script = {}
import style0 from "./home.vue?vue&type=style&index=0&id=675fc5dd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675fc5dd",
  null
  
)

export default component.exports